/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/Constants',[
    './Logger'
], function (Logger) {
    'use strict';

    var enums = {
        general: {
            DEFAULT_GUID: '00000000-0000-0000-0000-000000000000'
        },
        shippingRequestType: {
            UPDATE_ADDRESS: 0,
            SELECT_SERVICE: 1,
            BOTH: 2
        },
        deliveryType: {
            SHIPPING: 1,
            PICKUP: 2,
            VIRTUAL: 3
        },
        productType: {
            Simple: 'Simple',
            Group: 'Group',
            Kit: 'Kit',
            GiftCard: 'GiftCard'
        },
        inventoryAction: {
            DISABLE: 'Disable',
            OUT_OF_STOCK: 'OutOfStock',
            BACKORDER: 'BackOrder'
        },
        quickViewAction: {
            ADD_TO_CART: 'AddToCart',
            EDIT: 'Edit'
        },
        pagination: {
            Ascending: 0,
            Descending: 1
        },
        cartSource: {
            GET_CART: "GetCart",
            VALIDATE_CART: "ValidateCart",
            GET_ITEM: "GetItem",
            GET_CART_SUMMARY: "GetCartSummary",
            ADD_TO_CART: "AddToCart",
            UPDATE_ITEM_QUANTITY: "UpdateItemQuantity",
            REMOVE_FROM_CART: "RemoveFromCart",
            UPDATE_DELIVERY_OPTION: "UpdateDeliveryOption",
            SAVE_ITEM: "SaveItem",
            DELETE_SAVED_ITEM: "DeleteSavedItem",
            SAVE_CART: "SaveCart",
            LOAD_CART: "LoadCart",
            GET_SAVED_CARTS: "GetSavedCarts",
            MOVE_SAVED_ITEM_TO_CART: "MoveSavedItemToCart",
            UPDATE_SHIPPING_DETAILS: "UpdateShippingDetails",
            EMAIL_CART: "EmailCart",
            REORDER: "Reorder",
            APPLY_PROMOTION_CODE: "ApplyPromotionCode",
            REMOVE_PROMOTION_CODE: "RemovePromotionCode",
            LOAD_ITEMS_TO_CART: "LoadItemsToCart",
            RECALCULATE: "Recalculate"
        },
        invoiceHistoryPeriod: {
            MONTHTODATE: '0',
            LASTXMONTHS: '1',
            DATERANGE: '2'
        }
    };

    var events = {
        general: {
            CHANGE: 'change.ROC-APP'
        },

        reviews: {
            WRITE_RATE: 'reviews.WRITE_RATE'
        },

        address: {
            OPEN_BILLING_FORM: 'address.OPEN_BILLING_FORM'
        },

        users: {
            LOGIN: 'users.LOGIN',
            LOGOUT: 'users.LOGOUT',
            REGISTER: 'users.REGISTER',
            FORGOT_PASSWORD: 'users.FORGOT_PASSWORD',
            CHANGE_PASSWORD: 'users.CHANGE_PASSWORD',
            EDIT_ACCOUNT: 'users.EDIT_ACCOUNT'
        },

        cart: {
            PAGE_LOAD: 'cart.PAGE_LOAD',
            ORDER_CONFIRM: 'cart.ORDER_CONFIRM',
            LOAD_SAVED_CART: 'cart.LOAD_SAVED_CART',

            ADD_ITEM: 'cart.ADD_ITEM',
            UPDATE_ITEM: 'cart.UPDATE_ITEM',
            REMOVE_ITEM: 'cart.REMOVE_ITEM',
            SAVE_ITEM: 'cart.SAVE_ITEM',
            MOVE_SAVED_ITEM: 'cart.MOVE_SAVED_ITEM',
            REMOVE_SAVED_ITEM: 'cart.REMOVE_SAVED_ITEM',
            CART_SAVED: 'cart.CART_SAVED',
            UPDATE_SHIPPING_DETAILS: 'cart.UPDATE_SHIPPING_DETAILS',
            CART_REMOVED: 'cart.CART_REMOVED',
            CART_LOADED: 'cart.CART_LOADED',
            GET_SUMMARY: 'cart.GET_SUMMARY',
            RE_ORDER: 'cart.RE_ORDER',
            GET_CURRENT_CART: 'cart.GET_CURRENT_CART',
            APPLY_PROMO_CODE: 'cart.APPLY_PROMO_CODE',
            REMOVE_PROMO_CODE: 'cart.REMOVE_PROMO_CODE',
        },

        giftCards: {
            ASSOCIATE_PAYMENT: 'giftCards.ASSOCIATE_PAYMENT',
            REMOVE_PAYMENT: 'giftCards.REMOVE_PAYMENT'
        },

        favorites: {
            ADD_ITEM: 'favorites.ADD_ITEM',
            UPDATE_ITEM: 'favorites.UPDATE_ITEM',
            DELETE_ITEM: 'favorites.DELETE_ITEM',
            ADD_LIST: 'favorites.ADD_LIST',
            UPDATE_LIST: 'favorites.UPDATE_LIST',
            DELETE_LIST: 'favorites.DELETE_LIST',
            GET_ITEM: 'favorites.GET_ITEM',
            GET_LIST: 'favorites.GET_LIST',
            MOVE_ITEM: 'favorites.MOVE_ITEM',
            ADD_FRIEND: 'favorites.ADD_FRIEND',
            DELETE_FRIEND: 'favorites.DELETE_FRIEND',
            UPDATE_PRODUCT: 'favorites.UPDATE_PRODUCT'
        },

        products: {
            SELECTIONS_UPDATE: 'products.SELECTIONS_UPDATE'
        },

        delivery: {
            ADDRESS_BOOK_SELECTED: 'delivery.ADDRESS_BOOK_SELECTED',
            RECIPIENT_DATA_PROVIDED: 'delivery.RECIPIENT_DATA_PROVIDED',
            DELIVERY_OPTION_CHANGED: 'delivery.DELIVERY_OPTION_CHANGED'
        },

        checkout: {
            PAYMENT_TYPE_CHANGED: 'checkout.PAYMENT_TYPE_CHANGED',
            UPDATE_RECIPIENT: 'checkout.UPDATE_RECIPIENT'
        },

        templates: {
            RENDER_FORM_COMPLETED: 'templates.RENDER_FORM_COMPLETED'
        }

    };

    

    var Constants = {
        events: events,
        enums: enums
    };

    Logger.debug('Constants.js Loaded:', Constants);

    return Constants;
});

